import { render, staticRenderFns } from "./DemographicsSummary.vue?vue&type=template&id=b6f7cb2a&scoped=true&"
import script from "./DemographicsSummary.vue?vue&type=script&lang=js&"
export * from "./DemographicsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DemographicsSummary.vue?vue&type=style&index=0&id=b6f7cb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f7cb2a",
  null
  
)

export default component.exports